// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-tooltip__wrapper {
  position: absolute;
}
.v-tooltip__wrapper--fixed {
  position: fixed;
}
.v-tooltip__wrapper .v-tooltip__content {
  position: static;
}`, "",{"version":3,"sources":["webpack://./js/modules/assurance/components/interactive-vtooltip/InteractiveVTooltip.vue","webpack://./InteractiveVTooltip.vue"],"names":[],"mappings":"AACA;EACE,kBAAA;ACAF;ADCE;EACE,eAAA;ACCJ;ADCE;EACE,gBAAA;ACCJ","sourcesContent":["\n.v-tooltip__wrapper {\n  position: absolute;\n  &--fixed {\n    position: fixed;\n  }\n  .v-tooltip__content {\n    position: static;\n  }\n}\n",".v-tooltip__wrapper {\n  position: absolute;\n}\n.v-tooltip__wrapper--fixed {\n  position: fixed;\n}\n.v-tooltip__wrapper .v-tooltip__content {\n  position: static;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
